import script from "./BookingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingComponent.vue?vue&type=script&setup=true&lang=js"

import "./BookingComponent.vue?vue&type=style&index=0&id=4c4e0d1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4e0d1d"]])

export default __exports__